import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as reportService from '../../services/reportService';

export const getSalesReportAsync = createAsyncThunk(
    'reports/getSalesReport', 
    async (params: { start_date: string; end_date: string; branch_id?: number; category?: string }) => {
        const response = await reportService.getSalesReport(params);
        return response;
    }
);

export const getStockReportAsync = createAsyncThunk(
    'reports/getStockReport',
    async (params?: { branch_id?: number; category?: string; low_stock_only?: boolean }) => {
        const response = await reportService.getStockReport(params);
        return response;
    }
);

const reportsSlice = createSlice({
    name: 'reports',
    initialState: {
        salesReport: null as any,
        stockReport: null as any,
        loading: false,
        error: null as string | null,
    },
    reducers: {
        clearReports: (state) => {
            state.salesReport = null;
            state.stockReport = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSalesReportAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSalesReportAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.salesReport = action.payload;
            })
            .addCase(getSalesReportAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch sales report';
            })
            .addCase(getStockReportAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getStockReportAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.stockReport = action.payload;
            })
            .addCase(getStockReportAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch stock report';
            });
    },
});

export const { clearReports } = reportsSlice.actions;

// Selectors
export const selectSalesReport = (state: any) => state.reports.salesReport;
export const selectStockReport = (state: any) => state.reports.stockReport;
export const selectLoading = (state: any) => state.reports.loading;
export const selectError = (state: any) => state.reports.error;

export default reportsSlice.reducer;